
namespace TabAurous.Reports {


    @Serenity.Decorators.registerClass()
    export class OpenConsignmentInBifurcation extends Serenity.EntityGrid<StockBifurcationRow, any> {
        protected getColumnsKey() { return 'Purchase.OpenConsignmentInBifurcation'; }
        protected getIdProperty() { return StockBifurcationRow.idProperty; }
        protected getLocalTextPrefix() { return StockBifurcationRow.localTextPrefix; }
        protected getService() { return TabAurous.Purchase.OpenConsignmentInBifurcationService.baseUrl; }
        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;
        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Purchase/OpenConsignmentInBifurcation/PartyList',
                    idField: "LedgerName",
                    textField: "LedgerName",
                    multiple: true
                },
                field: 'PartyId',
                title: 'Vendor',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                        }
                    } else
                        (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });


            

            return filters;
        }
     
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();


            var plugin = new Slick.ColumnGroup();
            grid.registerPlugin(plugin);

            var columns = grid.getColumns();

            //grid.registerPlugin(new Slick.columng);

            for (let col of columns) {
                //console.log(col);
                if (col.field == "TransDate" || col.field == "VoucherNo" || col.field == "LedgerName" || col.field == "ProductCode" || col.field == "Pieces" || col.field == "Weight") col.groupName = "Approval Details";

                if (col.field == "PurchaseVoucher" || col.field == "PurchasePieces" || col.field == "PurchaseWeight") col.groupName = "Purchase/Return";
                //if (col.field == "SalesVoucher" || col.field == "SalesPieces" || col.field == "SalesWeight") col.groupName = "Sales";
                if (col.field == "RemainingPieces" || col.field == "RemainingWeight") col.groupName = "Balance";

            }
            plugin.enableColumnGrouping();

            grid.setColumns(columns);
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            //this.view.setSummaryOptions({
            //    aggregators: [
            //        new Slick.Aggregators.Sum('M1Pieces'),
            //        new Slick.Aggregators.Sum('M2Pieces'),
            //        new Slick.Aggregators.Sum('M3Pieces'),
            //        new Slick.Aggregators.Sum('M4Pieces'),
            //        new Slick.Aggregators.Sum('M5Pieces'),
            //        new Slick.Aggregators.Sum('M6Pieces'),
            //        new Slick.Aggregators.Sum('M7Pieces'),
            //        new Slick.Aggregators.Sum('M8Pieces'),
            //        new Slick.Aggregators.Sum('M9Pieces'),
            //        new Slick.Aggregators.Sum('M10Pieces'),
            //        new Slick.Aggregators.Sum('M11Pieces'),
            //        new Slick.Aggregators.Sum('M12Pieces'),
            //        new Slick.Aggregators.Sum('M1Amount'),
            //        new Slick.Aggregators.Sum('M2Amount'),
            //        new Slick.Aggregators.Sum('M3Amount'),
            //        new Slick.Aggregators.Sum('M4Amount'),
            //        new Slick.Aggregators.Sum('M5Amount'),
            //        new Slick.Aggregators.Sum('M6Amount'),
            //        new Slick.Aggregators.Sum('M7Amount'),
            //        new Slick.Aggregators.Sum('M8Amount'),
            //        new Slick.Aggregators.Sum('M9Amount'),
            //        new Slick.Aggregators.Sum('M10Amount'),
            //        new Slick.Aggregators.Sum('M11Amount'),
            //        new Slick.Aggregators.Sum('M12Amount')]
            //});


            //this.view.setGrouping([{
            //    formatter: g => {
            //        return "<span class='slick-group-title-header'>" +
            //            g.value +
            //            "<span class='slick-cell l2 r2'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Pieces + "</span></span>" +
            //            "<span class='slick-cell l3 r3'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l4 r4'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Pieces + "</span></span>" +
            //            "<span class='slick-cell l5 r5'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l6 r6'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Pieces + "</span></span>" +
            //            "<span class='slick-cell l7 r7'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l8 r8'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Pieces + "</span></span>" +
            //            "<span class='slick-cell l9 r9'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l10 r10'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Pieces + "</span></span>" +
            //            "<span class='slick-cell l11 r11'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l12 r12'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Pieces + "</span></span>" +
            //            "<span class='slick-cell l13 r13'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l14 r14'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Pieces + "</span></span>" +
            //            "<span class='slick-cell l15 r15'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l16 r16'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Pieces + "</span></span>" +
            //            "<span class='slick-cell l17 r17'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l18 r18'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Pieces + "</span></span>" +
            //            "<span class='slick-cell l19 r19'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l20 r20'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Pieces + "</span></span>" +
            //            "<span class='slick-cell l21 r21'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l22 r22'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Pieces + "</span></span>" +
            //            "<span class='slick-cell l23 r23'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l24 r24'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Pieces + "</span></span>" +
            //            "<span class='slick-cell l25 r25'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Amount.toFixed(2) + "</span></span>";
            //    },
            //    getter: 'ProductTypeName',
            //    displayTotalsRow: false,
            //}, {
            //    formatter: g => {
            //        return "<span class='slick-group-title-header'>" +
            //            g.value +
            //            "<span class='slick-cell l2 r2'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Pieces + "</span></span>" +
            //            "<span class='slick-cell l3 r3'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l4 r4'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Pieces + "</span></span>" +
            //            "<span class='slick-cell l5 r5'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l6 r6'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Pieces + "</span></span>" +
            //            "<span class='slick-cell l7 r7'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l8 r8'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Pieces + "</span></span>" +
            //            "<span class='slick-cell l9 r9'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l10 r10'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Pieces + "</span></span>" +
            //            "<span class='slick-cell l11 r11'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l12 r12'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Pieces + "</span></span>" +
            //            "<span class='slick-cell l13 r13'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l14 r14'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Pieces + "</span></span>" +
            //            "<span class='slick-cell l15 r15'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l16 r16'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Pieces + "</span></span>" +
            //            "<span class='slick-cell l17 r17'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l18 r18'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Pieces + "</span></span>" +
            //            "<span class='slick-cell l19 r19'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l20 r20'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Pieces + "</span></span>" +
            //            "<span class='slick-cell l21 r21'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l22 r22'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Pieces + "</span></span>" +
            //            "<span class='slick-cell l23 r23'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l24 r24'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Pieces + "</span></span>" +
            //            "<span class='slick-cell l25 r25'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Amount.toFixed(2) + "</span></span>";
            //    },
            //    getter: 'TypeName',
            //    displayTotalsRow: false

            //}, {
            //    formatter: g => {
            //        return "<span class='slick-group-title-header'>" +
            //            g.value +
            //            "<span class='slick-cell l2 r2'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Pieces + "</span></span>" +
            //            "<span class='slick-cell l3 r3'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l4 r4'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Pieces + "</span></span>" +
            //            "<span class='slick-cell l5 r5'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l6 r6'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Pieces + "</span></span>" +
            //            "<span class='slick-cell l7 r7'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l8 r8'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Pieces + "</span></span>" +
            //            "<span class='slick-cell l9 r9'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l10 r10'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Pieces + "</span></span>" +
            //            "<span class='slick-cell l11 r11'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l12 r12'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Pieces + "</span></span>" +
            //            "<span class='slick-cell l13 r13'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l14 r14'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Pieces + "</span></span>" +
            //            "<span class='slick-cell l15 r15'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l16 r16'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Pieces + "</span></span>" +
            //            "<span class='slick-cell l17 r17'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l18 r18'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Pieces + "</span></span>" +
            //            "<span class='slick-cell l19 r19'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l20 r20'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Pieces + "</span></span>" +
            //            "<span class='slick-cell l21 r21'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l22 r22'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Pieces + "</span></span>" +
            //            "<span class='slick-cell l23 r23'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Amount.toFixed(2) + "</span></span>" +
            //            "<span class='slick-cell l24 r24'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Pieces + "</span></span>" +
            //            "<span class='slick-cell l25 r25'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Amount.toFixed(2) + "</span></span>";
            //    },
            //    getter: 'SubCategoryName',
            //    displayTotalsRow: false

            //}])

            return grid;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Reports.ApprovalRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Open Consignments",
                onViewSubmit: () => this.onViewSubmit()
            }));
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: TabAurous.Purchase.OpenConsignmentInBifurcationService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            return buttons;
        }
    }
}